<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >

        <!--:libraryId="libraryId"-->


    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        created() {


        },
        mounted(){

        },
        components: {


        },
        computed: {

        },
       methods:{

       },
    }
</script>




// WEBPACK FOOTER //
// src/pages/files/index.vue